import styled, { css } from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Container = styled.div`
  padding: 0 15px;
`;

export const DrawerItemsTitle = styled(Typography.Caption).attrs({
  $variant: '2',
})<{ $hasTopGutter?: boolean }>`
  position: sticky;
  z-index: 1;
  top: 0;
  margin-left: 15px;
  margin-top: 5px;
  margin-bottom: 10px;
  color: ${({ theme }) => theme.palette.secondary.labels};
  background-color: ${({ theme }) => theme.palette.primary.background};

  ${({ $hasTopGutter }) =>
    $hasTopGutter &&
    css`
      margin-top: 30px;
    `}
`;
